<section id="breadCrumbContainer">
  <div [ngClass]="'breadcrumb breadcrumb-header'">
    <ul>
      @if (home) {
        <li class="breadcrumb-home">
          @if (!home.routerLink) {
            <a [routerLink]="home.url" class="menuitem-link" (click)="click($event, home)"
              [ngClass]="{'state-disabled':home.disabled}" [attr.target]="home.target" [attr.title]="home.title"
              [attr.id]="home.id">
              <i class="icon-font di di-home"></i>
            </a>
          }
          @if (home.routerLink) {
            <a [routerLink]="home.routerLink" [queryParams]="home.queryParams"
              [routerLinkActive]="'state-active'"
              [routerLinkActiveOptions]="home.routerLinkActiveOptions||{exact:false}" class="menuitem-link"
              (click)="click($event, home)" [ngClass]="{'state-disabled':home.disabled}"
              [attr.target]="home.target" [attr.title]="home.title" [attr.id]="home.id">
              <i class="di di-home"></i>
            </a>
          }
        </li>
      }
      @if (model&&home) {
        <li class="breadcrumb-chevron di di-next"></li>
      }
      @for (item of model; track item.id; let end = $last) {
        <li role="menuitem">
          @if (!item.routerLink) {
            <a [routerLink]="item.url" class="menuitem-link"
              (click)="click($event, item)" [ngClass]="{'state-disabled':item.disabled}"
              [attr.target]="item.target" [attr.title]="item.title" [attr.id]="item.id">
              @if (item.icon) {
                <i [ngClass]="item.icon"></i>
              }
              <span class="menuitem-text">{{item.label}}</span>
            </a>
          }
          @if (item.routerLink) {
            <a [routerLink]="item.routerLink" [queryParams]="item.queryParams"
              [routerLinkActive]="'state-active'"
              [routerLinkActiveOptions]="item.routerLinkActiveOptions||{exact:false}" class="menuitem-link"
              (click)="click($event, item)" [ngClass]="{'state-disabled':item.disabled}"
              [attr.target]="item.target" [attr.title]="item.title" [attr.id]="item.id">
              @if (item.icon) {
                <i [ngClass]="item.icon"></i>
              }
              <span class="menuitem-text">{{item.label}}</span>
            </a>
          }
        </li>
        @if (!end) {
          <li class="breadcrumb-chevron di di-next"></li>
        }
      }
    </ul>
  </div>
</section>